import React, { useRef, useEffect, Fragment } from "react"
import OutsideClickTrigger from "../common/OutsideClickTrigger"
import config from "react-global-configuration"
import LoginLink from "../common/loginLink"
import * as endpoint from "../../constants/Endpoints"
import * as trackingHelper from "../../helpers/tracking"
import Svg from "../../../shared/_svgs/svg"
import { parkingState } from "../../zustand/parkingState"
import priceFormatter from "../../helpers/priceFormatter"
import { handleReservation } from "../../helpers/apiHelper"
import { FlowEnum } from "../../constants/flowEnums"

const ParkingDetailsModal = ({
  item,
  isActive,
  userAccountDetails,
  manageBookingResult,
  handleParkingDetailsClose,
  handleParkingDetailsCleanup,
  handleSpecialProductClickFromDetails,
  history,
}) => {
  const textKeys = config.get("textKeys.parkingList.detailsModal") || {}
  const textKeysClose = config.get("textKeys.mainApp")
  const wpyfSettings = config.get("textKeys.weParkYouFlySettings") || {}
  const textKeysMember = config.get("textKeys.parkingList.memberProductModal") || {}
  const textKeysListElement = config.get("textKeys.parkingList.listElement") || {}

  const closeButtonRef = useRef(null)

  useEffect(() => {
    if (closeButtonRef != null) {
      closeButtonRef?.current?.focus() || undefined
    }
  }, [closeButtonRef])

  if (!item) return <Fragment></Fragment>

  const showAmendmentPriceDiff =
    parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOW || parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOWCHANGECARPARK

  const getPricingOptions = () => {
    const { carPark, result } = item
    console.log(item)
    const allProducts = parkingState.getState().allProducts
    const budgetProducts = allProducts.filter((x) => x.product.categoryName === "Budget")
    if (budgetProducts && budgetProducts.length > 0) {
      if (parkingState.getState().isParkingHighlightModalActive) {
        let options = budgetProducts.filter((p) => {
          if (p.carPark.id === carPark.id) return p
          if (p.carPark.name === "P15" && p.result.totalPrice > result.totalPrice) return p
        })
        options = options
          .map((p) => ({
            id: p.product.id,
            carParkName: p.carPark.name,
            price: p.result.totalPrice,
            isSoldOut: p.product.isSoldOut,
          }))
          .sort((x, y) => x.price - y.price)
        return options
      } else {
        const options = budgetProducts
          .filter((p) => p.carPark.id === carPark.id)
          .map((p) => ({
            id: p.product.id,
            carParkName: p.carPark.name,
            price: p.result.totalPrice,
            isSoldOut: p.product.isSoldOut,
          }))
          .sort((x, y) => x.price - y.price)
        return options
      }
    }
    return []
  }

  const renderBudgetPricing = (options) => {
    const { product } = item
    return (
      <div className="modal__middle">
        <ul className="parking-lot-price-options">{options.map((option, index) => renderPricingOption(product, option, index))}</ul>
      </div>
    )
  }

  const renderPricingOption = (product, option, index) => {
    // const textKeys = config.get("textKeys.parkingList.detailsModal") || {}

    const currentProduct = product.id === option.id
    let headline = <h6></h6>
    if (Math.abs(product.maxCapacity - product.currentlyBooked) <= 25 && !product.isSoldOut) {
      headline = <h6>{textKeys.fewSpots || "Få pladser online"}</h6>
    } else if (index === 0 && !currentProduct) {
      headline = <h6>{textKeys.budgetStartPrice || "Start pris"}</h6>
    } else if (index === 1 && !currentProduct) {
      headline = <h6>{textKeys.budgetNextPrice || "Næste pris"}</h6>
    } else if (index === 2 && !currentProduct) {
      headline = (
        <h6>
          {textKeys.budgetLastPrice || "Sidste pris"} - ({option.carParkName})
        </h6>
      )
    }
    const price = priceFormatter(option.price)
    return (
      <li key={index} className={`parking-lot-price-options__item ${getPricingOptionClassName(product, option)}`}>
        {headline}
        <h3>
          {option.isSoldOut ? (
            <>
              <s>{price}</s>
              <small>
                &nbsp;
                {product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed
                  ? wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"
                  : textKeys.soldOut || "Udsolgt"}
              </small>
            </>
          ) : (
            price
          )}
        </h3>
        {currentProduct && !option.isSoldOut && (
          <button
            className="button button--small button--general"
            onClick={() => handleParkingDetailsClose(handleReservation(product.id, item, handleParkingDetailsCleanup, history))}
          >
            <span className="text">{textKeys.reserveButton || "Reservér"}</span>
          </button>
        )}
      </li>
    )
  }

  const getPricingOptionClassName = (product, option) => {
    const isSignificant = product.id === option.id
    if (product.isSoldOut) {
      return "parking-lot-price-options__item--sold-out"
    } else if (isSignificant) {
      return "parking-lot-price-options__item--significant"
    } else {
      return 'parking-lot-price-options__item"'
    }
  }

  const handleConfirmClick = () => {
    upgradeProductTracking(parkingState.getState().trackingEventLabel)
    handleReservation(item.product.id, item, parkingState.getState().handleParkingDetailsCleanup, history)
  }

  const handleOverrideClick = () => {
    upgradeProductTracking(parkingState.getState().trackingEventLabel)
    parkingState.getState().buttonClickOverride()
  }

  const upgradeProductTracking = (eventLabel) => {
    if (Object.keys(parkingState.getState().upsaleTrackingData).length > 0)
      trackingHelper.trackParkingProductUpgrade(item, parkingState.getState().upsaleTrackingData, eventLabel)
  }

  const renderMemberProduct = (soldOut) => {
    // const textKeys = config.get("textKeys.parkingList.detailsModal") || {}

    // const wpyfSettings = config.get("textKeys.weParkYouFlySettings") || {}
    const { buttonTextOverride, buttonClickOverride, manageBookingResult } = parkingState.getState()
    const { product, result } = item
    let hasBeenLoggedIn = false
    let hasExtras = false
    let extrasAmount = 0
    if (manageBookingResult) {
      hasExtras = manageBookingResult.booking?.items?.extras[0]?.offerLines[0]?.amount ? true : false
      if (hasExtras) {
        extrasAmount = manageBookingResult.booking.items.extras[0].offerLines[0].amount
      }
      hasBeenLoggedIn = manageBookingResult.booking.membershipNumber ? true : false
    }

    const isLoggedIn = parkingState.getState().userAccountDetails ? true : false
    const memberPricePrefix = manageBookingResult ? (result.memberPrice - (manageBookingResult.booking.price - extrasAmount) > 0 ? "+" : "") : null
    const pricePrefix = manageBookingResult ? (result.totalPrice - (manageBookingResult.booking.price - extrasAmount) > 0 ? "+" : "") : null

    if (userAccountDetails || hasBeenLoggedIn) {
      return (
        <div className={"modal--parking-product-row-modal__price-and-cta"}>
          <div>
            {showAmendmentPriceDiff ? "" : <h6 className="headline-xxxs">{textKeysListElement.memberPrice || "Medlemspris"}</h6>}

            {showAmendmentPriceDiff && manageBookingResult ? (
              <h3>
                {memberPricePrefix}
                {priceFormatter(result.memberPrice - (manageBookingResult.booking.price - extrasAmount))}
              </h3>
            ) : (
              <h3>{priceFormatter(result.memberPrice)}</h3>
            )}

            {result.showDriveInPrice && !showAmendmentPriceDiff ? (
              <p className={""}>
                {textKeys.driveIn || "Drive in-pris: "} <span>{priceFormatter(result.barrierTariff)}</span>
              </p>
            ) : (
              ""
            )}
            {isLoggedIn || hasBeenLoggedIn ? (
              ""
            ) : (
              <p className="parking-product-table__sub">
                {textKeys.nonMemberPrice || "Ikke medlem"}: {pricePrefix}
                {showAmendmentPriceDiff && manageBookingResult
                  ? priceFormatter(result.totalPrice - (manageBookingResult.booking.price - extrasAmount))
                  : priceFormatter(result.totalPrice)}
              </p>
            )}
          </div>
          {!soldOut ? (
            <button
              className="button button--small button--general"
              onClick={() => handleParkingDetailsClose(buttonClickOverride ? handleOverrideClick() : handleConfirmClick())}
            >
              <span className="text">{buttonTextOverride ? buttonTextOverride : textKeys.reserveButton || "Reservér"}</span>
            </button>
          ) : product.isSoldOut && product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed ? (
            <button className="button button--small button--general is-disabled">
              <span className="text">{wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"}</span>
            </button>
          ) : (
            <button className="button button--small button--general is-disabled">
              <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
            </button>
          )}
        </div>
      )
    } else {
      return !soldOut ? (
        <div className={"modal--parking-product-row-modal__price-and-cta"}>
          <div>
            {showAmendmentPriceDiff ? "" : <h6 className="headline-xxxs">{textKeysListElement.memberPrice || "Pris med CPH profil"}</h6>}

            <h3>
              {showAmendmentPriceDiff ? memberPricePrefix : ""}
              {showAmendmentPriceDiff && manageBookingResult
                ? priceFormatter(result.memberPrice - (manageBookingResult.booking.price - extrasAmount))
                : result.memberPrice}{" "}
              {!showAmendmentPriceDiff ? textKeys.valuta || "DKK" : ""}{" "}
            </h3>
            <p>
              {textKeysMember.nonMemberPrice || "Ikke medlem"}:{" "}
              {showAmendmentPriceDiff && manageBookingResult
                ? pricePrefix + priceFormatter(result.totalPrice - (manageBookingResult.booking.price - extrasAmount))
                : priceFormatter(result.totalPrice)}
              {" - "}
              <button
                className="button--text-link"
                onClick={() => handleParkingDetailsClose(buttonClickOverride ? handleOverrideClick() : handleConfirmClick())}
              >
                <span className="text">{buttonTextOverride ? buttonTextOverride : textKeys.reserveButton || "Reservér"}</span>
              </button>
            </p>
          </div>
          <LoginLink
            loginurl={endpoint.ACCOUNT_LOGIN()}
            linkClassName={"button button--small button--general"}
            spanClassName={"text"}
            linkText={textKeysMember.loginLink || "Log ind / opret"}
            trackingHandler={() => trackingHelper.trackCTALoginButtonClick("parking - search")}
          />
        </div>
      ) : (
        <>
          <div className={"modal--parking-product-row-modal__price-and-cta"}>
            <div>
              <h3>
                {textKeys.valuta || "DKK"} {priceFormatter(result.totalPrice, true)}
              </h3>
              {result.showDriveInPrice && !showAmendmentPriceDiff ? (
                <p className={""}>
                  {textKeys.driveIn || "Drive in-pris: "} <span>{priceFormatter(result.barrierTariff)}</span>
                </p>
              ) : (
                ""
              )}
            </div>
            {product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed ? (
              <button className="button button--small button--general is-disabled">
                <span className="text">{wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"}</span>
              </button>
            ) : (
              <button className="button button--small button--general is-disabled">
                <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
              </button>
            )}
          </div>
        </>
      )
    }
  }

  const renderProduct = (soldOut) => {
    const { buttonTextOverride, buttonClickOverride, manageBookingResult } = parkingState.getState()
    const { product, result } = item

    let hasExtras = false
    let extrasAmount = 0
    if (manageBookingResult) {
      hasExtras = manageBookingResult.booking?.items?.extras[0]?.offerLines[0]?.amount ? true : false
      if (hasExtras) {
        extrasAmount = manageBookingResult.booking.items.extras[0].offerLines[0].amount
      }
    }
    const isSpecialProduct = product && product.dynamicFields && product.dynamicFields.isSpecialProduct
    const pricePrefix = manageBookingResult ? (result.totalPrice - (manageBookingResult.booking.price - extrasAmount) > 0 ? "+" : "") : null

    return (
      <div className={"modal--parking-product-row-modal__price-and-cta"}>
        <div>
          {showAmendmentPriceDiff && manageBookingResult ? (
            <h3>
              {pricePrefix}
              {priceFormatter(result.totalPrice - (manageBookingResult.booking.price - extrasAmount), true)} {textKeys.valuta || "DKK"}
            </h3>
          ) : (
            <h3>
              {textKeys.valuta || "DKK"} {priceFormatter(result.totalPrice, true)}
            </h3>
          )}
          {result.showOriginalPrice && !showAmendmentPriceDiff ? (
            <p className={"price-line-through"}>
              {textKeys.previousPrice || "Førpris:"} <span>{priceFormatter(result.originalPrice)}</span>
            </p>
          ) : result.showDriveInPrice && !showAmendmentPriceDiff ? (
            <p className={""}>
              {textKeys.driveIn || "Drive in-pris:"} <span>{priceFormatter(result.barrierTariff)}</span>
            </p>
          ) : (
            ""
          )}
        </div>
        {!soldOut ? (
          isSpecialProduct ? (
            <button className="button button--small button--general" onClick={() => handleSpecialProductClickFromDetails()}>
              <span className="text">{textKeys.reserveButton || "Reservér"}</span>
            </button>
          ) : (
            <button
              className="button button--small button--general"
              onClick={() => handleParkingDetailsClose(buttonClickOverride ? handleOverrideClick() : handleConfirmClick())}
            >
              <span className="text">{buttonTextOverride ? buttonTextOverride : textKeys.reserveButton || "Reservér"}</span>
            </button>
          )
        ) : product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed ? (
          <button className="button button--small button--general is-disabled">
            <span className="text">{wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"}</span>
          </button>
        ) : (
          <button className="button button--small button--general is-disabled">
            <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
          </button>
        )}
      </div>
    )
  }

  const options = getPricingOptions()
  const showMemberprice = item.result?.showMemberPrice
  let hasBeenLoggedIn = parkingState.getState().manageBookingResult?.booking?.membershipNumber ? true : false
  let usp = parkingState.getState().useNewDesign ? item.carParkUsp : item.usp
  let resume = parkingState.getState().useNewDesign ? item.carParkResume : item.resume

  if (!isActive) return ""

  const handleCloseModal = () => {
    const returnToNode = document.getElementById(parkingState.getState().modalOpenerId)
    if (returnToNode) returnToNode.focus()
  }

  return (
    <div className={"overlay overlay--modal overlay--fixed is-active"}>
      {!parkingState.getState().isParkingProductMapModalActive ? (
        <div
          className={`modal modal--parking-product-row-modal modal-rows-padded ${showMemberprice ? "" : "modal-rows-padded"} ${
            showMemberprice && (userAccountDetails || hasBeenLoggedIn) ? "modal-rows-padded" : ""
          }`}
        >
          <OutsideClickTrigger onOutsideClick={() => handleParkingDetailsClose(handleParkingDetailsCleanup)}>
            <>
              <button
                aria-label={`${textKeysClose?.modalCloseAriaLabel}`}
                ref={closeButtonRef}
                className="button button--icon js--close-modal"
                onClick={() => {
                  handleCloseModal(), handleParkingDetailsClose(handleParkingDetailsCleanup)
                }}
              >
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content modal__content--no-padding">
                <div className="modal__content__inner">
                  <div className="modal__top">
                    <header>
                      <div className={"modal__headline"}>
                        {parkingState.getState().useNewDesign ? (
                          <h3 className="headline-md">{item.carPark.name}</h3>
                        ) : (
                          <>
                            <h3 className="headline-md">{item.product.name}</h3>
                            <h6>{item.carPark.name}</h6>
                          </>
                        )}
                      </div>
                      {item.ribbonText ? <span className={"anchor-button anchor-button--parking"}>{item.ribbonText}</span> : ""}
                      <div className={"rich-text"}>
                        <span className="resume" dangerouslySetInnerHTML={{ __html: resume ? resume : item.product.description }}></span>
                        {usp && usp.headline ? <h6>{usp.headline}</h6> : null}
                        {usp && usp.bullets ? (
                          <ul className={usp.bullets.length < 6 ? "d-block--sm" : null}>
                            {usp.bullets.map((bullet, index) => (
                              <li key={index}>
                                <svg aria-hidden="true" tabIndex={-1} className="svg-icon svg-icon--checkmark">
                                  <use xlinkHref="/dist/svg/symbols.svg#svg-checkmark"></use>
                                </svg>
                                {bullet}
                              </li>
                            ))}
                          </ul>
                        ) : null}
                      </div>
                      <button
                        className="button button--link button--link--significant has-icon"
                        onClick={() =>
                          parkingState.setState({
                            isParkingProductMapModalActive: true,
                            isParkingSpecialProductActive: false,
                            isParkingDetailsModalActive: false,
                          })
                        }
                      >
                        {parkingState.getState().useNewDesign ? (
                          <Svg isDecorative={true} iconName={"pin2"} fillColor={"none"} stroke={"#060e4d"} />
                        ) : (
                          <Svg isDecorative={true} iconName={"pin"} />
                        )}
                        <span className="text">{textKeys.map || "Se på kort"}</span>
                      </button>
                    </header>
                  </div>
                  {item.product.categoryName === "Budget" && options.length > 1 ? (
                    renderBudgetPricing(options)
                  ) : (
                    <div className="modal__bottom">
                      {showMemberprice ? renderMemberProduct(item.product.isSoldOut) : renderProduct(item.product.isSoldOut)}
                    </div>
                  )}
                </div>
              </div>
            </>
          </OutsideClickTrigger>
        </div>
      ) : null}
    </div>
  )
}

export default ParkingDetailsModal
